<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="guests"
          :search="search"
          class="elevation-1 mt-4"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RestResource from "../../../services/dataServiceWebsite";
const service = new RestResource();

export default {
  data() {
    return {
      guests: [],
      headers: [
        { text: "Email", value: "email" },
        { text: "Name", value: "name" },
        { text: "Company Name", value: "company" },
        { text: "Number of Pax", value: "noOfPax" },
      ],
      search: ''
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.$setLoader()
      service.getRsvpData().then((r) => {
        this.guests = r.data.data;
      });
      this.$disableLoader()
    },
  },
};
</script>

<style scoped>
.d-flex {
  display: flex;
}
.justify-end {
  justify-content: flex-end;
}
</style>
